<template>
  <div class="artist-info-part artist-info-part__basic">
    <div class="platforms">
      <div class="platform-img" v-for="(item,platform_code) in platforms_images" :key="platform_code">
        <img v-if="info.platforms&&info.platforms[platform_code]==='Y'" :src="item" alt="" />
      </div>
    </div>
    <img class="cover_url" :src="info.cover_url" alt="" />
    <div class="infos">
      <div class="nickname">
        {{ info.nickname }}
        <span class="dept_name">{{ info.dept ? info.dept.name : '--' }}</span>
      </div>
      <div class="desc">肤质：{{ info.skin_type || '-' }}；标签：{{ info.kol_label || '-' }}。</div>
      <div class="sign">
        <span v-if="info.sign_status === 'Y'" class="sign-tag y">已签约</span>
        <span v-else class="sign-tag n">已解约</span>
        <span class="sign-time">合作时长：{{ info.duration ? info.duration : '--' }} 月</span>
        <span class="sign-time">签约时间： {{ info.sign_start|parseTime }} ~  {{ info.sign_end|parseTime }}</span>
        <span v-if="info.sign_status === 'N'" class="sign-time">解约时间：{{ info.fired_at | parseTime }}</span>
        <span class="sign-time">录入时间：{{ info.created_at }}</span>
        <span class="sign-time">更新时间：{{ info.updated_at }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ArtistLog from '@/pages/artist/ArtistLog'

export default {
  name: 'ArtistInfo',
  components: { ArtistLog },
  data() {
    return {
      searchCondition: { artist_id: null },
      info: {},
      purpose: 'is_data_entry',
      showLogView: false,
      platforms_images: {}
    }
  },
  props: {
    artistId: {
      type: String,
      require: true
    }
  },
  watch: {
    artistId(val) {
      this.searchCondition.artist_id = val
      this.getInfo()
    }
  },
  methods: {
    showLog() {
      this.showLogView = !this.showLogView
    },
    async getInfo() {
      const { info } = await this.$api.getArtistInfo(this.artistId)
      this.info = info
    },
    /**
     * 获取平台信息的方法
     *
     * @returns {Promise<void>} 无返回值
     */
    async getPlatforms() {
      // 处理平台信息的函数
      const dealPlatforms = function() {
        // 从localStorage中读取平台缓存信息，如果不存在则返回一个空数组
        const platforms_cache = localStorage.getItem('platforms') ? JSON.parse(localStorage.getItem('platforms')) : []
        const map = {}
        platforms_cache.forEach(platform => {
          // 将平台代码作为键，平台logo的URL作为值存入map中
          map[platform.code] = platform.logo_url || ''
        })
        return map
      }

      //从缓存中读取上次的平台信息
      const platformsJson = localStorage.getItem('platforms')
      if (platformsJson) {
        this.platforms_images = dealPlatforms()
      }
      // 获取最新平台信息
      const searchCondition = this.handleSearchCondition()
      const { list } = await this.$api.getPlatformAll(searchCondition)
      // 缓存平台信息
      localStorage.setItem('platforms', JSON.stringify(list))
      this.platforms_images = dealPlatforms()
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      condition.status = 1

      if (this.purpose === 'is_data_entry') {
        condition.is_data_entry = 1
      }

      if (this.purpose === 'is_plc_entry') {
        condition.is_plc_entry = 1
      }
      return condition
    }
  },
  created() {
    this.searchCondition.artist_id = this.artistId
    this.getPlatforms()
    this.getInfo()
  }
}
</script>

<style lang="scss">
.artist_mini-basic {
  padding: 0.83vw 1.66vw;
  border-radius: 12px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;

  .artist_mini-basic_left {
    display: flex;
    align-items: center;

    .cover_url-mini {
      width: 2.083vw;
      height: 2.083vw;
      border-radius: 9999px;
    }

    .nickname-mini {
      font-size: 0.83vw;
      margin-left: 0.83vw;
      font-weight: bold;
      line-height: 1.25vw;
      letter-spacing: normal;
      color: #000000;
    }
  }

  .artist_mini-basic_right {
    a {
      font-size: 0.83vw;
      font-weight: normal;
      line-height: 20px;
      text-align: center;
      letter-spacing: normal;
      color: #6B7280;
      padding: 0.83vw 0.83vw;
      cursor: pointer;
    }

    a.active {
      color: #FF4B55;
      border-bottom: 2px solid #FF4B55;
    }
  }
}

.artist-info-part__basic {
  padding: 1.66vw;
  display: flex;
  flex-direction: row;
  position: relative;
  border-radius: 12px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);

  .platforms {
    position: absolute;
    right: 1.66vw;
    top: 1.66vw;
    display: flex;

    .platform-img {
      img {
        width: 1.66vw;
        height: 1.66vw;
        margin-left: 0.83vw;
      }
    }
  }

  .cover_url {
    width: 8vw;
    height: 8vw;
    border-radius: 9999px;
  }

  .infos {
    margin-left: 1.66vw;
    align-content: center;

    .nickname {
      font-size: 1.25vw;
      font-weight: bold;
      line-height: 1.66vw;
      letter-spacing: normal;
      color: #000000;
      display: flex;
    }

    .dept_name {
      font-size: 14px;
      font-weight: normal;
      letter-spacing: normal;
      color: #4b5563;
      border-radius: 16px;
      padding: 0 0.83vw;
      background: #f3f4f6;
      margin-left: 0.83vw;
    }

    .desc {
      font-size: 0.83vw;
      font-weight: normal;
      line-height: 1.25vw;
      letter-spacing: normal;
      color: #4b5563;
      margin: 0.83vw 0;
    }

    .sign-tag {
      flex-direction: column;
      padding: 0.3vw 0.83vw;
      font-size: 0.83vw;
      border-radius: 9999px;
      background: #ff4b55;
      color: #fff;
    }

    .sign-tag.n {
      background: #6b7280;
    }

    .sign-time {
      margin-left: 1.66vw;
      font-size: 0.83vw;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: normal;
      color: #6b7280;
    }
  }
}

</style>
